// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1Ywqy","messages":"Chat_messages__1sdOB","dateDivider":"Chat_dateDivider__3vjjn"};